<template>
 
  <div id="Vue"  >
 
  <el-row  >
  <el-col :span="22" :offset="1"> 
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left" >
    <el-breadcrumb separator-class="el-icon-arrow-right" style="  margin-top:3px;margin-left:10px;margin-bottom:30px;">
  <el-breadcrumb-item :to="{ path: '/customs/index' }">海关数据</el-breadcrumb-item>
  <el-breadcrumb-item>广交会数据</el-breadcrumb-item> 
  </el-breadcrumb>

  <el-tabs v-model="activeName" type="card"  >
  <el-tab-pane label="在线查询" name="first">
  
  <el-form ref="form"  :inline="true" :model="form" label-width="80px" class="demo-form-inline">
  <el-form-item label="行业类别"  >
    <el-select v-model="form.type" placeholder="请选择">
                            <el-option
                                    v-for="item in cateOptions"
                                    :key="item.id"
                                    :label="item.category"
                                    :value="item.category">
                            </el-option>		  
    </el-select>
  </el-form-item> 
 
 
  <el-form-item label="公司名称">
    <el-input v-model="form.keywords" placeholder="选填"  @keyup.enter.native="onSubmit"></el-input>
  </el-form-item>
  
  <el-form-item>
    <el-button type="primary" :loading="loading" @click="onSubmit" >查询</el-button> 
  </el-form-item>
 
  
  </el-form>
  
  
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left" >
 
  
  <el-table v-loading="loading"
    :data="tableData" 
	border 
    style="width: 100%"
	 
     >
    <el-table-column
      prop="id"
      label="id" 
	  v-if="id==-1" 
      width="0%">
    </el-table-column>
    <el-table-column
      fixed
      prop="COMPANY_NAME"
      label="公司名称"
      min-width="16%">
    </el-table-column>
    <el-table-column
      fixed
      prop="STATE"
      label="国家"
      min-width="5%">
    </el-table-column>	
    <el-table-column
      fixed
      prop="PROCUREMENT_OF_PRODUCTS"
      label="行业描述"
      min-width="16%">
    </el-table-column>
    <el-table-column
      prop="CONTACT_GROUP"
      label="联系人"
      min-width="10%">
    </el-table-column>	
    <el-table-column
      fixed
      prop="EMAIL"
      label="邮箱"
      min-width="10%">
    </el-table-column>	
    <el-table-column
      prop="WEBSITE"
      label="网址"
      min-width="10%">
    </el-table-column> 	
    <el-table-column
      prop="ADDRESS"
      label="地址"
      min-width="10%">
    </el-table-column>

    <el-table-column
      prop="ZIP"
      label="邮编"
      min-width="3%">
    </el-table-column>	
    <el-table-column
      prop="PHONE"
      label="电话"
      min-width="5%">
    </el-table-column>		
    <el-table-column
      prop="FAX"
      label="传真"
      min-width="5%">
    </el-table-column>

  </el-table>
  <div style="margin-top:10px; display: flex; align-items:right; justify-content: flex-end;  ">

  <el-pagination v-show="!loading" @current-change="handlePageChange" :current-page="page" :page-size="10" 
   layout="total, prev, pager, next, jumper  " 
   :total="total">
  </el-pagination> 
				
  </div>
  </el-row>  
  </el-tab-pane>
  
  <el-tab-pane label="数据下载" name="second">
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
 
  <el-form ref="form"  :inline="true" :model="form" label-width="80px" class="demo-form-inline">
  
  <el-form-item label="展期(届)"  >
    <el-select v-model="form.term" placeholder="请选择">
                            <el-option
                                    v-for="item in termOptions" 
                                    :label="item.term"
                                    :value="item.term">
                            </el-option>		  
    </el-select>
  </el-form-item>  
  
  <el-form-item>
    <el-button type="primary" :loading="loading" @click="queryInfo" >查询</el-button> 
  </el-form-item>
 
  
  </el-form>
  </el-row> 
  
  <el-table v-loading="loading"
    :data="linkData" 
	border 
    style="width: 100%" >
    <el-table-column
      fixed
      prop="file_url"
      label="link" 
	  v-if="user_id==-1"
      min-width="30%">
    </el-table-column>
    <el-table-column
      fixed
      prop="category"
      label="类别"
      min-width="30%">
    </el-table-column>
    <el-table-column
      fixed
      prop="record_count"
      label="记录数"
      min-width="20%">
    </el-table-column>	
     
  
    <el-table-column 
      label="操作" 
	  width="280"
      min-width="10%">
	  	 <template slot-scope="scope">
				<el-button   size="mini"   @click="handleDownload(scope.$index, scope.row)">下载</el-button> 
	  </template>
    </el-table-column>
  </el-table>
 
  
  </el-tab-pane>
  </el-tabs> 
  </el-row>
  </el-col>
  </el-row>
  
</div>
</template>
<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

<script>
  
export default {
 
        data () {
            return {
	    	componentName: 'info',
		    userInfo: {}, 
			user_id: 0,
			loading: false,
			login_state : false,
			id: 0,
			page: 1,
			size:10,
		    total: 0,
			buttonQuery: 1,
			status:true,
			tableHeight: '600px',
			dialogVisible: false,
			category : 'search',
			cateOptions: [],
			termOptions: [],
			activeName: 'first',
			form:{ region:'', 
			       keywords:'',
				   type: '办公用品', 
				   term: '',
				   COMPANY_NAME:'',
				   SIC_DESCRIPTION: '',
				   EMAIL: '',
				   ADDRESS: '',
				   CITY:'',
				   PHONE_NUMBER:'',
				   FAX_NUMBER:'',
				   STATE: '', 
				   
				 },
			tableData:[],
			linkData: [],
			}  
        },
        methods: {
 
			handlePageChange(val) {
				this.page = val;
				this.buttonQuery = 0;
				//保存到localStorage
				localStorage.setItem('adPage', this.page)
				localStorage.setItem('adFilterForm', JSON.stringify(this.filterForm));
				this.getInfo() 
			},	
			handleDownload(index,row){
			   let that = this; 
			   let isVip = 0;
			   that.$axios.get ('https://www.myferp.com/admin/user/isVip',{
			                  headers:{ 
                             "X-Nideshop-Token": localStorage.getItem('token')},
							 params: {user_id: that.user_id }
							 }).then((response) => {
			                console.log('category: ' + JSON.stringify(response) );
							if (response.data.errno == 0) { 
								isVip = response.data.data.isVip; 
								if (isVip == 1)
								    window.open(row.file_url, '_blank');
								else
									that.$message({
									message: 'VIP用户才可以下载 ! ',
									type: 'error'
									});
							    }
	 
							})
			    
			},
			
		    onSubmit(){
			/*	if (this.form.keywords == ''){
				    this.$message({
							message: '关键词不能为空 ! ',
							type: 'warning'
							});
				    return;
				}	*/		    
			    this.category = 'search';
			    this.page = 1; 
				this.buttonQuery = 1;
				this.getInfo('');
				},
			getInfo(){ 
				if ( this.user_id == 0){
				    this.$message({
							message: '登录后查看更多 ! ',
							type: 'success'
							});
				    return;
				}
 
				let that = this;  				 
				that.loading = true;
				that.tableHeight = "800px";
				
				
				let data = {
				              user_id: that.user_id, 
					          page: that.page , 
							  size: 10,   
							  type:that.form.type,
							  keywords:that.form.keywords,
							  buttonQuery: that.buttonQuery, 
				};
				that.$axios ({
				   method: 'post', 
				   url: 'https://www.myferp.com/admin/gd/gdSearch',
				   data : data ,
                   headers:  {"X-Nideshop-Token": localStorage.getItem('token')}				   
					 }).then((response) => {
					console.log('category: ' + JSON.stringify(response) );
					if (response.data.errno == 500){
						      that.$message({
							  message: '未查询到相关数据， 换个词试试! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
					if (response.data.errno == 0) {
						that.loading = false; 

						  that.tableData = response.data.data.data ; 
						  that.page = parseInt(response.data.data.currentPage )  ;
						  that.total = response.data.data.count;
						  that.loading = false;	
					   }

					})
				/*  $.ajax({
					  type: "POST",
					  data:  {user_id: that.user_id, 
					          page: that.page , 
							  size: 10,   
							  type:that.form.type,
							  keywords:that.form.keywords,
							  buttonQuery: that.buttonQuery, 
							  },
					  url: "https://www.myferp.com/admin/user/gdSearch",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: data,
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						  console.log(JSON.stringify(data));
						  if (data.errno == 500){
						      that.$message({
							  message: '未查询到相关数据， 换个词试试! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 200){  //非注册用户每天查询最多两次
						      that.$message({
							  message: '登录后查看更多! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						if (data.errno == 100){  //未付费注册用户每天查询最多五次
						      that.$message({
							  message: '成为会员后查看更多! ',
							  type: 'error'
							  });
							  that.loading = false;	
                              that.status = true;	
							  that.total = 0;
							  that.page = 0;
							  that.id = 0;
                              that.tableData = [];							  
							  return;
						     }
						  that.tableData = data.data.data ; 
						  that.page = parseInt(data.data.currentPage )  ;
						  that.total = data.data.count;
						  that.loading = false;					  
						  }
					  }); */
		    },
			
			login()
			{
			  this.$router.push({
					path: '/login',
					params: {
					  sometext: ''
					}
				  }); 
			},

			back()
			{ 
			  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });  
			},
			download(){

			  this.category = 'download';
			},
			getCategory(){
			   let that = this;
			   that.loading = true;  
			   that.$axios.get ('https://www.myferp.com/admin/gd/category',{
			                  headers:{"X-Nideshop-Token": localStorage.getItem('token')},
							 params: { }
							 }).then((response) => {
			                console.log('category: ' + JSON.stringify(response) );
							if (response.data.errno == 0) {
							    that.loading = false;
								that.termOptions = response.data.data.term; 
								that.cateOptions = response.data.data.info;
							   }
	 
							})
							
			 
			},
			queryInfo(){
			   let that = this;
			   that.loading = true;  
			   that.$axios.get ('https://www.myferp.com/admin/gd/gdFair',{
			                  headers:{ 
                             "X-Nideshop-Token": localStorage.getItem('token')},
							 params: { term: that.form.term}
							 }).then((response) => {
							if (response.data.errno == 0) {
							    that.loading = false;
								that.linkData = response.data.data.info.data;  
							   }
	 
							})			
			},

		},
        mounted() { 
		   // this.form.type = '办公文具设备'; 
			//this.getInfo();
			let userInfo = localStorage.getItem('userInfo'); //判断登录状态
			console.log( 'user:' + typeof userInfo);  
 
			let info = {}; 
			if (userInfo != null && userInfo != '' && typeof userInfo != undefined){
				info = JSON.parse(userInfo);
				this.user_id = info.id;  
				}
				
			this.getCategory();
			
           },		   
		
    } ;

</script>
 


// WEBPACK FOOTER //
// src/components/customs/gdSearch.vue